export const GET_GROUPS_PATH = 'api/landlord/team/groups';